module.exports = {
  title: "dev.taeyeong",
  description: "Hello",
  author: "taeyeong",
  siteUrl: "https://dev-taeyeong.github.io",
  links: {
    github: "https://github.com/dev-taeyeong",
    linkedIn: "https://linkedin.com",
    facebook: "https://www.facebook.com",
    instagram: "https://www.instagram.com",
    email: "mailto:dev.taeyeong@gmail.com",
  },
  utterances: {
    repo: "dev-taeyeong/dev-taeyeong.github.io",
    type: "pathname",
  },
}
